export const usersType = [
  { label: "Administrador", id: 1 },
  { label: "Consultor", id: 2 },
];
